import React from "react";
import { useNavigate } from "react-router-dom";

function InsideHeader({ title, subtitle, back, handleGoBack, compact = false }) {
  const navigate = useNavigate();
  const handleGoBackDefault = () => {
    navigate(-1);
  };
  return (
    <>
      <div
        className={`weiser-page-header ${
          compact ? "weiser-page-header-compact" : ""
        } lg:flex hidden justify-between items-center`}
      >
        <div className="flex flex-col">
          <span
            className={`weiser-page-title ${
              compact ? "weiser-page-title-compact" : ""
            } dash-title`}
          >
            {title}
          </span>
          <span className="weiser-page-subtitle font-dmSans">
            {subtitle}
          </span>
        </div>

        {back && (
          <div className="flex items-center">
            <button
              type="button"
              onClick={handleGoBack ? handleGoBack : handleGoBackDefault}
              className="weiser-page-back bg-transparent flex items-center"
            >
              <div className="weiser-page-back-icon flex justify-center items-center rounded-full w-[40px] h-[40px] p-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="24"
                  viewBox="0 0 28 24"
                  fill="none"
                >
                  <path
                    d="M17.7692 18L11.0469 12L17.7692 6"
                    stroke="#147CBC"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="weiser-page-back-label font-dmSans">
                Go Back
              </span>
            </button>
          </div>
        )}
      </div> 
    </>
  );
}

export default InsideHeader;
